import React from 'react';
import { Global, css, ThemeProvider } from '@emotion/react'
import { light, dark, textStyles } from './Theme';

const WithThemeProvider = (props) => {
    const rem = 16;
    const baseTheme = {
        spacing: {
            quarter: rem/4+'px', // 4
            third: rem/3+'px', // 6
            half: rem/2+'px', // 8
            threeQuarter: 3/4*rem+'px', // 12
            single: rem+'px', // 16
            double: rem*2+'px', // 32
            triple: rem*3+'px', // 48
        },
        borderRadius: '5px',
        colors: {
            danger: '#E35D5D',
            preorderBackground: '#FCCF47',
            preorderText: '#2C2C2C', 
            secondaryButton: '#37647D'
        }
    };

    const colorStyles = (props.colorScheme === 'dark') ? dark : light;
    const theme = {
        ...baseTheme,
        textStyles,
        colorStyles,
    };

    return (
        <ThemeProvider theme={theme}>
            <Global styles={css`
                body {
                    background-color: ${theme.colorStyles.Background};
                    font-family: Lato, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                    color: ${theme.colorStyles.LabelPrimary};
                    font-size: 16px;
                    margin: 0;
                    padding: 0;
                }
                .swiper-container {
                    padding-left: 15px;
                    padding-bottom: 30px;
                    padding-right: 15px;
                }
                .swiper-slide {
                    width: 80vw;
                }
                .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
                    bottom: 0;
                }
                .swiper-pagination-bullet-active {
                    background: #629EBF;
                }
                .GoldenTicketModal {
                    margin: 0 auto;

                    @media (min-width: 768px) {
                        margin: 30px auto;
                        min-width: 600px !important;
                    }

                }

                .markdown {
                    p:last-child {
                        margin-bottom: 0px;
                    }
                }
            `} />
            {props.children}
        </ThemeProvider>
    );
}

export default WithThemeProvider;